import { push } from '@lagunovsky/redux-react-router'
import HomeAction from 'home/actions/HomeAction'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import AppStore from 'store/AppStore'
import { H_PLUVIO_CAMPAIGN } from '../../../account/constants/AccessRulesConstants'
import CampaignAction from '../../../campaign/actions/CampaignAction'
import DashboardCampaigns from '../../../campaign/components/DashboardCampaigns'
import CampaignDto from '../../../campaign/dto/CampaignDto'
import DtoCampaignProgress from '../../../campaign/dto/DtoCampaignProgress'
import ProgressCard from '../../../components/card/ProgressCard'
import SieauAction from '../../../components/sieau/SieauAction'
import { PATH_PLUVIOMETRY, PATH_PLUVIOMETRY_CAMPAIGN } from '../../../home/constants/RouteConstants'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import PluviometerDto from '../../dto/PluviometerDto'


class PluviometryCampaigns extends Component {
    state = {
        progress: 0,
        dataLoaded: false,
    }

    componentDidMount = () => {
        if (!componentHasHabilitations(H_PLUVIO_CAMPAIGN)) { // A modifier quand react-router sera à jour
            this.props.push('/unauthorized')
            return
        }
        AppStore.dispatch(HomeAction.setHelpLink('pluviometrie', ''))
        this.props.loadPluviometryCampaigns(p => this.setState({ progress: p }))
            .then(() => this.setState({ dataLoaded: true }))
        this.props.forceFetch('title', [{
            title: i18n.pluviometry,
            href: PATH_PLUVIOMETRY,
        }, {
            title: i18n.campaigns,
            href: PATH_PLUVIOMETRY_CAMPAIGN,
        }])
    }

    render = () => {
        const {
            progress,
            dataLoaded,
        } = this.state
        const {
            pluviometers,
            pluviometryCampaigns,
            pluviometryCampaignsProgress,
        } = this.props
        return dataLoaded ? (
            <DashboardCampaigns
                stations={pluviometers}
                campaigns={pluviometryCampaigns}
                campaignsProgress={pluviometryCampaignsProgress}
                stationType={'pluviometry'}
            />
        ) : (
            <ProgressCard progress={progress} />
        )
    }
}

PluviometryCampaigns.propTypes = {
    getLink: PropTypes.func,
    pluviometers: PropTypes.arrayOf(PropTypes.instanceOf(PluviometerDto)),
    pluviometryCampaigns: PropTypes.arrayOf(PropTypes.instanceOf(CampaignDto)),
    pluviometryCampaignsProgress: PropTypes.arrayOf(PropTypes.instanceOf(DtoCampaignProgress)),

    forceFetch: PropTypes.func,
    loadPluviometryCampaigns: PropTypes.func,
    push: PropTypes.func,
}

const mapStateToProps = store => ({
    pluviometers: store.PluviometryReducer.pluviometers,
    pluviometryCampaigns: store.PluviometryReducer.pluviometryCampaigns,
    pluviometryCampaignsProgress: store.PluviometryReducer.pluviometryCampaignsProgress,
})

const mapDispatchToPorops = {
    forceFetch: SieauAction.forceFetch,
    loadPluviometryCampaigns: CampaignAction.loadPluviometryCampaigns,
    push,
}

export default connect(mapStateToProps, mapDispatchToPorops)(PluviometryCampaigns)
